<template>
  <div class="ack-tracker">
    <h6 class="ack-tracker__title">Acknowledgment Status</h6>
    <AIVTable
      :columns="columns"
      :data="caregiverStatuses"
      :item-name="'caregivers'"
      v-loading="loading"
    >
      <template #cell-status="{ row }">
        <el-tag size="mini" :type="row.acknowledged && !row.needsReAck ? 'success' : 'danger'">
          {{ row.acknowledged && !row.needsReAck ? 'Signed' : 'Pending' }}
        </el-tag>
      </template>
      <template #cell-acknowledgedAt="{ row }">
        {{ row.acknowledgedAt ? formatDate(row.acknowledgedAt) : '-' }}
      </template>
      <template #cell-version="{ row }">
        {{ row.cstVersion || '-' }} / {{ row.currentVersion }}
      </template>
    </AIVTable>
  </div>
</template>

<script>
import { cstService } from "@/serviceHandlers/cstService";
import dayjs from "dayjs";

export default {
  name: "CstAcknowledgmentTracker",
  props: {
    cstId: { type: Number, required: true },
  },
  data() {
    return {
      caregiverStatuses: [],
      loading: false,
      columns: [
        { key: "caregiverName", label: "Caregiver" },
        { key: "status", label: "Status", sortable: false },
        { key: "acknowledgedAt", label: "Signed At" },
        { key: "version", label: "Version", sortable: false },
      ],
    };
  },
  watch: {
    cstId: {
      immediate: true,
      handler(val) {
        if (val) this.fetchAcknowledgments();
      },
    },
  },
  methods: {
    async fetchAcknowledgments() {
      this.loading = true;
      try {
        const result = await cstService.getAcknowledgments(this.cstId);
        this.caregiverStatuses = result.caregiverStatuses || [];
      } catch (error) {
        this.$notifyError("Could not load acknowledgments.");
      } finally {
        this.loading = false;
      }
    },
    formatDate(d) {
      return d ? dayjs(d).format("MM/DD/YYYY h:mm A") : "";
    },
  },
};
</script>

<style scoped>
.ack-tracker__title { color: #fff; margin-bottom: 0.75rem; }
</style>
